import React from 'react';
import { BillingLinks } from './BillingLinks.js';

/** The dashboard's footer once payments are on: legal links and "Verträge hier kündigen". */
export const BillingFooter: React.FC = () => (
  <footer style={{ padding: '8px 24px 32px', maxWidth: 1200, margin: '0 auto' }}>
    <BillingLinks includeImprint />
  </footer>
);
